
// TODO: [SR-2676] remove experiments.crossSellModal2Sections
import { mapGetters } from 'vuex'

import IllustrationDango from '@core/illustrations/IllustrationDango.svg'
import CarouselSkeleton from '@recommendation/components/CarouselSkeleton.vue'
import RecommendedProductsCarousel from '@recommendation/components/RecommendedProductsCarousel.vue'
import { logger } from '@recommendation/helpers'
import recommendationAPIClient from '@recommendation/recommendationAPIClient'
import { PRODUCT_SOURCE_TYPE } from '@tracking'

import { CATEGORIES } from './RecommendationCrossSell.constants'
import translations from './RecommendationCrossSell.translations'

export default {
  components: {
    CarouselSkeleton,
    IllustrationDango,
    RecommendedProductsCarousel,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      [CATEGORIES.CROSS_SELL_PROTECTION]: {
        fetching: true,
        widgetId: '',
        products: [],
      },
      [CATEGORIES.CROSS_SELL_ONE]: {
        fetching: true,
        widgetId: '',
        products: [],
      },
    }
  },
  computed: {
    // TODO: [SR-2676] remove experiments.crossSellModal2Sections
    ...mapGetters({
      experiments: 'flags/getExperiments',
    }),
    translations: () => translations,
    trackingList: () => PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL,
    trackingListCrossSellProtection() {
      // cross sell modal 1
      return `${PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL} 1`
    },
    trackingListCrossSellOne() {
      // TODO: [SR-2676] remove experiments.crossSellModal2Sections
      // cross sell modal 2
      if (
        this.experiments.crossSellModal2Sections ===
        'CrossSellModalWith2SectionsProtectionOtherAccessories'
      ) {
        return `${PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL} 2`
      }

      // cross sell modal
      return PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL
    },
    scopeId() {
      return String(this.listingId)
    },
    shouldDisplayErrorState() {
      return (
        !this.shouldDisplayLoadingState &&
        !this.shouldDisplayCrossSellOne &&
        !this.shouldDisplayCrossSellProtection
      )
    },
    shouldDisplayLoadingState() {
      return (
        this[CATEGORIES.CROSS_SELL_ONE].fetching ||
        this[CATEGORIES.CROSS_SELL_PROTECTION].fetching
      )
    },
    shouldDisplayCrossSellOne() {
      return (
        !this.shouldDisplayLoadingState &&
        this[CATEGORIES.CROSS_SELL_ONE].products.length > 0
      )
    },
    shouldDisplayCrossSellProtection() {
      return (
        // TODO: [SR-2676] remove experiments.crossSellModal2Sections
        this.experiments.crossSellModal2Sections ===
          'CrossSellModalWith2SectionsProtectionOtherAccessories' &&
        !this.shouldDisplayLoadingState &&
        this[CATEGORIES.CROSS_SELL_PROTECTION].products.length > 0
      )
    },
  },
  watch: {
    scopeId(newScopeId, previousScopeId) {
      if (newScopeId !== previousScopeId) {
        this[CATEGORIES.CROSS_SELL_ONE].fetching = true
        this[CATEGORIES.CROSS_SELL_PROTECTION].fetching = true
        this.fetchRecommendations()
      }
    },
  },
  mounted() {
    this.fetchRecommendations()
  },
  methods: {
    fetchRecommendations() {
      this.fetchRecommendationsForCategory(CATEGORIES.CROSS_SELL_PROTECTION)
      this.fetchRecommendationsForCategory(CATEGORIES.CROSS_SELL_ONE)
    },
    async fetchRecommendationsForCategory(category) {
      try {
        const { products, widgetId } = await recommendationAPIClient(
          (request) => this.$store.dispatch('http/request', request),
        ).getRecommendedProducts({
          category,
          limit: 12,
          scope: 'addToCart',
          scopeId: this.scopeId,
        })

        if (products === undefined || products.length === 0) {
          throw new Error(
            `no recommended products available for category: ${category}`,
          )
        }

        this[category].products = products
        this[category].recommendationWidgetId = widgetId
      } catch (err) {
        logger.info(err, {
          component: { name: 'RecommendationCrossSell', props: this.$props },
          routeName: this.$route.name,
        })
      } finally {
        this[category].fetching = false
      }
    },
    addToCart({ category, listingId }) {
      this[category].products = this[category].products.filter(
        (p) => p.listing.id !== listingId,
      )
    },
  },
}
